import React, {useContext, useState, useEffect} from "react";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";

import {useCurrentUser} from "../../customHooks/useContextCurrentUser";
import {useMap} from "./useContextMap";
import {useApiClient} from "../../customHooks/useApiClient";


const MapDispatchContext = React.createContext();


export const MapDispatchProvider = ({children}) => {
    const [userRole, setUserRole] = useState();

    const dispatch = useDispatch();

    const user = useCurrentUser();
    const {mapId} = useMap();
    const api = useApiClient();

    const updateRights = async () => {
        if (user === undefined || mapId === undefined) {
            return;
        }

        const mapMembers = (await api.get(`/api/v2/map/members/?map_id=${mapId}`)).data;
        let currentUserMemberRole = undefined;
        for (let i = 0; i < mapMembers.length; i++) {
            if (mapMembers[i].user_id === user.id) {
                currentUserMemberRole = mapMembers[i].role;
                break;
            }
        }
        setUserRole(currentUserMemberRole);
    };
    
    useEffect(async () => {
        await updateRights();
        const interval = setInterval(
            updateRights,
            60000
        );
        return () => clearInterval(interval);
    }, [user, mapId]);

    const mapDispatch = (action) => {
        // we allow to execute any action for a local map
        if (user === undefined) {
            dispatch(action);
            return;
        }
        if (mapId === undefined) {
            dispatch(action);
            return;
        }
        if (["author", "editor"].includes(userRole)) {
            dispatch(action);
            return;
        }

        toast.error('Нет прав на редактирование карты!');
        return 'error';
    };

    return <MapDispatchContext.Provider value={mapDispatch}>{children}</MapDispatchContext.Provider>;
};


export const useMapDispatch = () => useContext(MapDispatchContext);
